import type { DebugSection } from "../types";
import { defineDebugSection } from "../defineDebugSection";
import { environmentSection } from "./environmentSection";

/** The sections of Web, CMS and Integrations. Each loads when it is opened; Web adds its own Cache section. */
export const sharedDebugSections: DebugSection[] = [
  environmentSection,
  defineDebugSection({
    id: "session",
    label: "debug_tools.sections.session",
    icon: "key",
    component: () => import("./SessionSection.vue"),
    order: 20,
  }),
  defineDebugSection({
    id: "stores",
    label: "debug_tools.sections.stores",
    icon: "database",
    component: () => import("./StoresSection.vue"),
    order: 30,
  }),
  defineDebugSection({
    id: "toasts",
    label: "debug_tools.sections.toasts",
    icon: "bell",
    component: () => import("./ToastsSection.vue"),
    order: 40,
  }),
  defineDebugSection({
    id: "user",
    label: "debug_tools.sections.user",
    icon: "user",
    component: () => import("./UserSection.vue"),
    order: 50,
  }),
  defineDebugSection({
    id: "locales",
    label: "debug_tools.sections.locales",
    icon: "languages",
    component: () => import("./LocalesSection.vue"),
    order: 60,
  }),
];
